import { useStaticQuery, graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";

export function SEO({
  description = "",
  lang = "en",
  meta = [],
  title,
  image,
}: SEOProps) {
  const { site } = useStaticQuery<QueryTypes>(SEOStaticQuery);
  const siteUrl = site.siteMetadata?.siteUrl;
  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title
  const metaImage = `${siteUrl}${image}` || `${siteUrl}${site.siteMetadata?.image}`;
  const titleTemplate = title.length > 1 ? `${title} - ${defaultTitle}`: `${defaultTitle}`;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title.length > 1 ? title : defaultTitle}
      titleTemplate={title.length > 1 ? `%s - ${defaultTitle}`: '%s'}
      meta={[
        {
          name: `twitter:card`,
          content: `summary_large_image`
        },
        {
          name: `og:image`,
          content: `${siteUrl}${image}`,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: metaImage,
        },
        {
          property: `og:title`,
          content: titleTemplate,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.twitterUsername || ``,
        },
        {
          name: `twitter:title`,
          content: titleTemplate,
        },
        {
          name: `twitter:image:alt`,
          content: "Nexus Health",
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `og:site_name`,
          content: "Nexus Health"
        },
        {
          name: `og:url`,
          content: "https://nexushealth.ca",
        },
        {
          name: `fb:app_id`,
          content: site.siteMetadata?.facebookID,
        },
        {
          name: `image`,
          content: metaImage,
        },
      ].concat(meta)}
    />
  );
}

// Types
type SEOProps = {
  description?: string;
  lang?: string;
  meta?: Meta;
  title: string;
  image?: string;
};

type Meta = ConcatArray<PropertyMetaObj | NameMetaObj>;

type PropertyMetaObj = {
  property: string;
  content: string;
};

type NameMetaObj = {
  name: string;
  content: string;
};

type QueryTypes = {
  site: {
    siteMetadata: {
      title: string;
      description: string;
      twitterUsername: string;
      image: string;
      siteUrl: string;
      facebookID: string;
    };
  };
};

// Queries
const SEOStaticQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        twitterUsername
        image
        siteUrl
        facebookID
      }
    }
  }
`;
